<!--产品册详情-->
<template>
    <div class='main'>
        <van-swipe class="swiper" :show-indicators="false" :loop="false">
            <van-swipe-item v-for="(item, index) in detailList.contentName" :key="index">
                <img class='img' :src="item" alt="" />
            </van-swipe-item>
        </van-swipe>
    </div>
</template>

<script>
import request from "@/utils/request";
import { Swipe, SwipeItem } from 'vant';

export default {
    name: "productVolumeDetail",
    components: {
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
    },
    data() {
        return {
            treatmentId: "", //标题个数
            detailList: []
        };
    },
    mounted() {
        this.treatmentId = this.$route.query.id;
        this.onLoad();
    },
    methods: {
        onLoad() {
            request({
                url: `/brochure/${this.treatmentId}`,
                method: "get",
            })
                .then((res) => {
                    this.detailList = res.data;
                }).catch(() => {
                    this.detailList = [];
                }).finally(() => {
                });
        },
    },
}
</script>

<style lang="less" scoped>
.main {
    width: 100%;
    height: 100%;
}
.swiper {
    width: 100%;
    height: 100vh;
    overflow-y: auto;
}
.img {
    border-top: 1px solid #ededed;
    border-bottom: 1px solid #ededed;
    width: 100%;
    object-fit: cover;
}
</style>
